/**
 * 교회 정보 하드코딩 데이터
 */

export const CHURCH_INFO = {
  name: "위례세움교회",
  vision: "하나님의 사랑으로 세워지고, 성령의 능력으로 성장하며, 그리스도의 복음으로 세상을 섬기는 교회",
  address: "경기도 성남시 수정구 위례광장로 19 아이페리온 8층",
  phone: "0507-1427-6080",
  email: "sewoomch@naver.com",
  pastor: {
    name: "최성광",
    greeting: `"할렐루야! 주님 안에서 문안 드립니다"

위례세움교회 담임목사로 부르심을 받은 최성광 목사입니다.

제가 사역하는 위례세움교회는,
1. 이 시대에 구원의 등불을 비추는 교회입니다.(눅12:35) 잃어버린 영혼을 찾아 생명의 길로 인도하고 있습니다.(눅15:6)
2. 그리고 영적으로 깨어 있어 예수 그리스도의 재림의 날을 예비하고 준비하는 교회입니다.(눅21:36) 주님 앞에 나아가 칭찬과 상을 받게 될 날을 바라보며 열심히 믿음의 경주를 하고 있습니다.(고전9:24)

이 시대 제일 중요한 교회 선택의 기준은,
오직 예수님의 바른 말씀을 전하고 가르치며, 양육하는 교회입니다.(히4:12)
예수님의 말씀으로 심판을 받을 것이기 때문입니다.(요12:48)

영적으로 혼란스럽고 많은 미혹이 있는 시대 속에서
최선을 다하여 하나님의 바른 말씀을 전하고 있습니다.
참된 진리의 말씀을 따라 신앙생활을 하기 원하시는 모든 분들을
환영하고 축복합니다.`,
    photoUrl: "https://via.placeholder.com/400x500?text=Pastor+Photo"
  },
  worship: [
    {
      name: "주일 오전1부 예배",
      time: "오전 09:00",
      location: "본당"
    },
    {
      name: "주일 오전2부 예배",
      time: "오전 11:00",
      location: "본당"
    },
    {
      name: "주일 오후예배",
      time: "오후 1:30",
      location: "본당"
    },
    {
      name: "수요예배",
      time: "오후 7:30",
      location: "본당"
    },
    {
      name: "새벽기도회",
      time: "오전 5:30",
      location: "본당"
    },
    {
      name: "금요성령집회",
      time: "오후 9:00",
      location: "본당"
    }
  ],
  location: {
    lat: 37.4783,
    lng: 127.1446,
    address: "경기도 성남시 수정구 위례광장로 19 아이페리온 8층",
    directions: "남위례역 3번출 도보 5분 거리"
  }
};
